/**
 * Header nav con dropdowns en hover - estilo heylove
 */
document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const navItems = header.querySelectorAll('header-menu[data-hover-nav]');
  let closeTimeout;

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  navItems.forEach(function(menu) {
    const details = menu.querySelector('details');
    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.header__dropdown-menu, .mega-menu__content');

    if (!details || !summary || !content) return;

    function open() {
      if (!isDesktop()) return;
      clearTimeout(closeTimeout);
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      if (header.preventHide !== undefined) header.preventHide = true;
    }

    function close() {
      if (!isDesktop()) return;
      closeTimeout = setTimeout(function() {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        if (header.preventHide !== undefined) header.preventHide = false;
      }, 150);
    }

    function cancelClose() {
      clearTimeout(closeTimeout);
    }

    summary.addEventListener('mouseenter', open);
    summary.addEventListener('mouseleave', close);
    content.addEventListener('mouseenter', cancelClose);
    content.addEventListener('mouseenter', open);
    content.addEventListener('mouseleave', close);
    menu.addEventListener('mouseleave', close);
  });
});
